import Helper from "./Helper";

class NoteFixer {
  constructor() {
    
  }

  fix(el) {
    const noteLinks = el.parentNode.querySelectorAll('.note__link');
    noteLinks.forEach(element => {
      const currentHref = element.dataset.href;
      if(currentHref.includes('false')){
        element.dataset.href = currentHref.replace('false', '5');
      }
    });
  }
}

export default NoteFixer;